var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 9.726a2 2 0 0 0-.805.17l-14.8 6.511a2 2 0 0 0-1.195 1.831v19.413a2 2 0 0 0 2.785 1.839L28 33.51V9.726Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 45.006a2 2 0 0 0 2.806 1.83l12.801-5.632a2 2 0 0 0 1.194-1.83V18.237a2 2 0 0 0-1.194-1.83l-14.8-6.513A2 2 0 0 0 28 9.726v35.28Z",
    fill: "#D1D4D6"
  })));
};
export default SvgShield;